import type { MouseEvent, ReactNode } from 'react';

import { cn } from '@/utils/cn';

interface CheckboxProps {
  checked?: boolean;
  indeterminate?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: ReactNode;
  className?: string;
  id?: string;
  'aria-label'?: string;
}

export function Checkbox({
  checked = false,
  indeterminate = false,
  onChange,
  disabled,
  label,
  className,
  id,
  'aria-label': ariaLabel,
}: CheckboxProps) {
  const box = (
    <span
      className={cn('ds-cb', checked && 'checked', indeterminate && 'indeterminate', className)}
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      aria-disabled={disabled || undefined}
      aria-label={!label ? ariaLabel : undefined}
      tabIndex={disabled ? -1 : 0}
      id={id}
      onClick={(e: MouseEvent) => {
        if (disabled) return;
        e.stopPropagation();
        onChange?.(!checked);
      }}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          onChange?.(!checked);
        }
      }}
    />
  );

  if (!label) return box;

  return (
    <label className="ds-cb-row" aria-disabled={disabled || undefined}>
      {box}
      <span>{label}</span>
    </label>
  );
}
